import { BaseField as CssModulesBaseField, type BaseFieldInputProps as CssModulesBaseFieldInputProps, type BaseFieldProps as CssModulesBaseFieldProps, Input as CssModulesInput, ValidationStatuses } from '@sunwebgroup/uds-ui/fields/base-field'
import { styled } from 'styled-components'

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/fields/base-field' instead.
 */
export type BaseFieldInputProps = CssModulesBaseFieldInputProps

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/fields/base-field' instead.
 */
export type BaseFieldProps = CssModulesBaseFieldProps

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/base-field' instead.
 */
const StyledInput = styled(CssModulesInput)<BaseFieldInputProps>``

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/base-field' instead.
 */
const StyledValidationIcon = styled(CssModulesBaseField.ValidationIcon)<{ status: ValidationStatuses }>``

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/base-field' instead.
 */
const StyledBaseField = styled(CssModulesBaseField.BaseField)<BaseFieldProps>``

export { StyledBaseField as BaseField, StyledInput as Input, StyledValidationIcon }
